import React, { useEffect, useState } from "react";
import api from "../services/axiosInstance";
import { FaUser, FaUserPlus, FaInfoCircle, FaHeart, FaRegHeart, FaBookmark, FaRegBookmark } from "react-icons/fa";

const CategoryCoursesModal = ({ category, onClose, onSelectCourse }) => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [likedCourses, setLikedCourses] = useState({});
  const [savedCourses, setSavedCourses] = useState({});
  const [academicYears, setAcademicYears] = useState([]); 
  console.log("category")
  useEffect(() => {
  document.body.style.overflow = "hidden";
  return () => {
    document.body.style.overflow = "auto";
  };
}, []);

  useEffect(() => { 
    const fetchCategoryCourses = async () => {
      try { 
        const { data } = await api.get(`/courses/category/${category.toLowerCase()}`);
        if (data.years) {
  setAcademicYears(data.years);
  setCourses([]); // clear normal courses
  return;
}
        const transformed = data.map(course => ({
          ...course,
          gradient: getRandomGradient(),
          instructor: {
            ...course.instructor,
            gradient: getInstructorGradient()
          }
        }));
        setCourses(transformed);
      } catch (error) {
        console.error("Error fetching category courses:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryCourses();
  }, [category]);

  const getRandomGradient = () => {
    const gradients = [
      "from-blue-600 to-blue-800",
      "from-red-600 to-red-800",
      "from-green-600 to-teal-600",
      "from-purple-600 to-purple-800",
      "from-orange-600 to-orange-800",
      "from-indigo-600 to-indigo-800",
    ];
    return gradients[Math.floor(Math.random() * gradients.length)];
  };

  const getInstructorGradient = () => {
    const gradients = [
      "from-blue-500 to-purple-600",
      "from-red-500 to-pink-600",
      "from-green-500 to-teal-600",
      "from-purple-500 to-pink-600",
      "from-orange-500 to-red-600",
      "from-indigo-500 to-purple-600",
    ];
    return gradients[Math.floor(Math.random() * gradients.length)];
  };

  const toggleLike = (id) => {
    setLikedCourses(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleSave = (id) => {
    setSavedCourses(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const registerCourse = (course) => {
    alert(`Inscription au cours ${course.name}`);
  };

  const handleCourseDetails = async (course) => {
  if (course.isAcademicYears) {
    const { data } = await api.get("/courses/academic-years");
    setAcademicYears(data.years);
    setCourses([]);
    return;
  }

  onSelectCourse(course);
};


  return (
<div className="w-full max-w-6xl">

      <button
  onClick={onClose}
  className="mb-6 px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors"
>
  ← Retour
</button>
 
      <h3 className="text-3xl font-bold mb-6 text-gray-800">{category}</h3>

      {loading ? ( 
        <p className="text-center py-8">Chargement des cours...</p>
      ) : academicYears.length > 0 ?(  <div>
    <h2 className="text-2xl font-bold mb-4">Années Académiques gratuit</h2>
    <div className="grid grid-cols-1 gap-4">
      {academicYears.map((item, index) => (
        <a
          key={index}
          href={item.fileLink}
          target="_blank"
          rel="noopener noreferrer"
          className="p-4 bg-blue-50 rounded-xl border border-blue-200 hover:bg-blue-100 transition"
        >
          <span className="text-lg font-semibold text-blue-700">{item.year}</span>
        </a>
      ))}
    </div>
  </div>):
       courses.length === 0 ? (
        <p className="text-center py-8">Aucun cours disponible dans cette catégorie.</p>
      ) : (
        <div className="grid md:grid-cols-3 gap-2">
          {courses.map(course => (
            <div
              key={course.id}
         className="course-card rounded-xl shadow-lg overflow-hidden bg-white hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col min-h-[420px]"
  >
              <div className={`bg-gradient-to-r ${course.gradient} text-white p-6 text-center`}>
                <h4 className="text-xl font-bold">{course.name}</h4>
                <p className="opacity-90 mt-2">{course.description}</p>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div
                    className={`w-10 h-10 bg-gradient-to-br ${course.instructor.gradient} rounded-full flex items-center justify-center mr-3`}
                  >
                    <FaUser className="text-white text-sm" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-800">{course.instructor.name}</p>
                    <p className="text-xs text-gray-500">{course.niveau || "Niveau non spécifié"}</p>
                  </div>
                </div>

                <div className="flex justify-between items-center mb-4">
                  <span className="text-2xl font-bold text-blue-600">
                    {course.price ? `${course.price} DA` : "Gratuit"}
                  </span>
                  <div className="flex space-x-3">
                    <button
                      className={`p-2 rounded-full transition-colors ${
                        likedCourses[course.id]
                          ? "text-red-500 bg-red-50 hover:bg-red-100"
                          : "text-gray-400 hover:text-red-500 hover:bg-gray-100"
                      }`}
                      onClick={() => toggleLike(course.id)}
                    >
                      {likedCourses[course.id] ? <FaHeart className="text-red-500" /> : <FaRegHeart />}
                    </button>

                    <button
                      className={`p-2 rounded-full transition-colors ${
                        savedCourses[course.id]
                          ? "text-green-500 bg-green-50 hover:bg-green-100"
                          : "text-gray-400 hover:text-green-500 hover:bg-gray-100"
                      }`}
                      onClick={() => toggleSave(course.id)}
                    >
                      {savedCourses[course.id] ? <FaBookmark className="text-green-500" /> : <FaRegBookmark />}
                    </button>
                  </div>
                </div>

                <div className="flex gap-2">
                  <button
                    className="bg-blue-600 text-white px-4 py-2 rounded flex-1 hover:bg-blue-700 transition-colors font-medium flex items-center justify-center gap-2"
                    onClick={() => registerCourse(course)}
                  >
                    <FaUserPlus />
                    S'inscrire
                  </button>
                  <button
                    className="border border-blue-600 text-blue-600 px-4 py-2 rounded flex-1 hover:bg-blue-600 hover:text-white transition-colors font-medium flex items-center justify-center gap-2"
                    onClick={() => handleCourseDetails(course)}
                  >
                    <FaInfoCircle />
                    Détails
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
 
export default CategoryCoursesModal; 